import _Box from "@mui/material/Box";
import React from 'react';
import { useTranslation } from 'react-i18next';
import PointsRuleCard from './points-rule-card';
const metricConfig = {
  sum_trace_distance_m: {
    labelKey: 'commons.challenges.custom_metrics.sum_trace_distance_m.label',
    factor: 1000,
    unitKey: 'commons.challenges.custom_metrics.sum_trace_distance_m.unit'
  },
  sum_commuting_trace_distance_m: {
    labelKey: 'commons.challenges.custom_metrics.sum_commuting_trace_distance_m.label',
    factor: 1000,
    unitKey: 'commons.challenges.custom_metrics.sum_commuting_trace_distance_m.unit'
  },
  count_trace: {
    labelKey: 'commons.challenges.custom_metrics.count_trace.label',
    factor: 1,
    unitKey: 'commons.challenges.custom_metrics.count_trace.unit'
  },
  count_commuting_trace: {
    labelKey: 'commons.challenges.custom_metrics.count_commuting_trace.label',
    factor: 1,
    unitKey: 'commons.challenges.custom_metrics.count_commuting_trace.unit'
  },
  sum_trace_positive_denivele_m: {
    labelKey: 'commons.challenges.custom_metrics.sum_trace_positive_denivele_m.label',
    factor: 1,
    unitKey: 'commons.challenges.custom_metrics.sum_trace_positive_denivele_m.unit'
  },
  sum_trace_duration_s: {
    labelKey: 'commons.challenges.custom_metrics.sum_trace_duration_s.label',
    factor: 3600,
    unitKey: 'commons.challenges.custom_metrics.sum_trace_duration_s.unit'
  },
  count_cycling_days: {
    labelKey: 'commons.challenges.custom_metrics.count_cycling_days.label',
    factor: 1,
    unitKey: 'commons.challenges.custom_metrics.count_cycling_days.unit'
  },
  count_commuting_days: {
    labelKey: 'commons.challenges.custom_metrics.count_commuting_days.label',
    factor: 1,
    unitKey: 'commons.challenges.custom_metrics.count_commuting_days.unit'
  }
};

// Maps each commuting metric to its non-commuting equivalent: a home-work trip counts towards
// both metrics, so its actual point yield is the sum of the two weights.
const commutingToBaseMetric = {
  sum_commuting_trace_distance_m: 'sum_trace_distance_m',
  count_commuting_trace: 'count_trace',
  count_commuting_days: 'count_cycling_days'
};
const ZONE_BONUS_POINTS = 5;
function CustomPointsRules({
  eventCode,
  metricsWeights
}) {
  const metrics = metricsWeights;
  const activeMetrics = Object.keys(metricConfig).reduce((acc, key) => {
    const baseKey = commutingToBaseMetric[key];
    if (baseKey) {
      const weight = (metrics[key] ?? 0) + (metrics[baseKey] ?? 0);
      if (weight > 0) acc.push([key, weight]);
    } else if ((metrics[key] ?? 0) > 0) {
      acc.push([key, metrics[key] ?? 0]);
    }
    return acc;
  }, []);
  const hasZoneBonus = eventCode?.toLowerCase().startsWith('bfg_') ?? false;
  if (activeMetrics.length === 0 && !hasZoneBonus) return null;
  return /*#__PURE__*/React.createElement(_Box, {
    display: "flex",
    flexDirection: "column",
    gap: 2,
    sx: {
      containerType: 'inline-size'
    }
  }, activeMetrics.map(([key, weight]) => /*#__PURE__*/React.createElement(MetricCard, {
    key: key,
    metricKey: key,
    weight: weight
  })), hasZoneBonus && /*#__PURE__*/React.createElement(ZoneBonusCard, null));
}
function ZoneBonusCard() {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(PointsRuleCard, {
    direction: "row",
    label: t('commons.challenges.custom_faq.zone_bonus.label'),
    value: `+ ${ZONE_BONUS_POINTS} ${t('commons.challenges.custom_faq.zone_bonus.unit')}`
  });
}
function MetricCard({
  metricKey,
  weight
}) {
  const {
    t
  } = useTranslation();
  const {
    labelKey,
    factor,
    unitKey
  } = metricConfig[metricKey];
  const displayValue = Math.round(weight * factor * 100) / 100;
  return /*#__PURE__*/React.createElement(PointsRuleCard, {
    direction: "row",
    label: t(labelKey),
    value: `+ ${displayValue} ${t(unitKey)}`
  });
}
export default CustomPointsRules;